const importTranslations = async (locale: string): Promise<{ default: Record<string, string> }> => {
	switch (locale) {
		case 'cs-CZ':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-cs" */ './cs'
			);
		case 'da-DK':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-da" */ './da'
			);
		case 'de-DE':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-de" */ './de'
			);
		case 'en-US':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-en" */ './en'
			);
		case 'en-GB':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-en_GB" */ './en_GB'
			);
		case 'es-ES':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-es" */ './es'
			);
		case 'fi-FI':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-fi" */ './fi'
			);
		case 'fr-FR':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-fr" */ './fr'
			);
		case 'hu-HU':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-hu" */ './hu'
			);
		case 'it-IT':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-it" */ './it'
			);
		case 'ja-JP':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-ja" */ './ja'
			);
		case 'ko-KR':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-ko" */ './ko'
			);
		case 'no-NO':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-nb" */ './nb'
			);
		case 'nl-NL':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-nl" */ './nl'
			);
		case 'pl-PL':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-pl" */ './pl'
			);
		case 'pt-BR':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-pt_BR" */ './pt_BR'
			);
		case 'ru-RU':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-ru" */ './ru'
			);
		case 'sv-SE':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-sv" */ './sv'
			);
		case 'tr-TR':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-tr" */ './tr'
			);
		case 'th-TH':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-th" */ './th'
			);
		case 'uk-UA':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-uk" */ './uk'
			);
		case 'vi-VN':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-vi" */ './vi'
			);
		case 'zh-TW':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-zh_TW" */ './zh_TW'
			);
		case 'zh-CN':
			return import(
				/* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-zh" */ './zh'
			);
		default:
			return Promise.resolve({ default: {} });
	}
};

const fetchTranslations = async (locale: string): Promise<Record<string, string>> => {
	const module = await importTranslations(locale);
	return module.default;
};

export default fetchTranslations;
